import styled, { css } from 'styled-components';
import MuiButton from '@material-ui/core/Button';

const PaymentTipContainer = styled.div`
  background: transparent;
  border-radius: 0;
  margin-bottom: 12px;
  padding: 8px 0 0;
  border: 0;
  box-shadow: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      display: flex;
      flex-direction: column;
    }
  `}
  @media (min-width: 768px) {
    padding: 10px 0 0;
  }
`;
const Title = styled.div`
  font-size: 14px;
  line-height: 18px;
`;

const ButtonContainer = styled.div`
  margin-bottom: 24px;
`;

const ChipContainer = styled.div`
  padding: 0px;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
`;

const ButtonChip = styled(MuiButton)`
  && {
    border-radius: 100px;
    box-shadow: none;
    color: #334155;
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    transition: all 0.15s ease;
    border: 1px solid #dbe3ef;
    padding: 10px 16px;
    min-width: 92px;
    width: auto;
    text-transform: none;
    margin: 0;
    background: rgba(255, 255, 255, 0.95);

    @media (max-width: 400px) {
      font-size: 11px;
      padding-left: 6px;
      padding-right: 6px;
    }

    &:hover {
      background: #eef4ff;
      border-color: #9edcf0;
      box-shadow: none;
    }

    &.active {
      background: linear-gradient(135deg, #00c2de 0%, #00a8d8 100%);
      border-color: #00a8d8;
      color: #ffffff;
      box-shadow: 0 8px 16px rgba(0, 177, 217, 0.3);
    }
  }
`;

const Button = styled(MuiButton)`
  && {
    border-radius: 8px;
    box-shadow: none;
    color: #2153fd;
    font-weight: bold;
    font-size: 18px;
    line-height: 21px;
    border: 2px solid #2153fd;
    width: 100%;
    height: 56px;
    margin-top: 17px;
  }
`;

const ShowTips = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
`;

const AddTip = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
`;

const RemoveTip = styled.span`
  font-weight: 600;
  font-size: 13px;
  line-height: 18px;
  color: #64748b;
  cursor: pointer;
  text-align: end;
  &:hover {
    color: #334155;
  }
`;

const RemoveTipButton = styled.button`
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.color.PLColor1};
  text-align: end;
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
`;

const RemoveTipLink = styled.button`
  display: block;
  margin: -4px 0 0 auto;
  padding: 4px 0;
  background: transparent;
  border: none;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
  cursor: pointer;
  transition: color 0.15s ease;
  font-family: 'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  text-align: right;

  &:hover {
    color: #ef4444;
  }
`;

const TitleLayout = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export {
  TitleLayout,
  PaymentTipContainer,
  ButtonContainer,
  Title,
  ButtonChip,
  ChipContainer,
  Button,
  RemoveTipButton,
  RemoveTipLink,
  ShowTips,
  AddTip,
  RemoveTip,
};
